<template>
  <div class="page-con">
    <input :placeholder="formatMessage({id:'5g.message.h5.components.searchAddress',defaultMessage:'搜索地址'})" id="mapSearch" v-model="searchText" class="searchInput" />
      <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
    <!-- </el-input> -->
    <!-- <div class="locationText">
      经度 <b>{{longitude}}</b>，纬度 <b>{{latitude}}</b><br />
      地址：<b>{{address}}</b>
    </div> -->
    <div class="map-con" ref="mapCon">
      <div class="map" v-bind:style="{height: mapHeight + 'px'}" id="mapContainer"></div>
    </div>
    <div class="footer" >
      <el-button @click="cancleClick" class="footer-btn">{{formatMessage({id:'5g.message.h5.common.name.clear',defaultMessage:'取消'})}}</el-button>
      <el-button style="margin-left: 0;" @click="sendClick" type="warning" class="footer-btn">{{formatMessage({id:'5g.message.h5.chatRoom.send',defaultMessage:'发送'})}}</el-button>
    </div>
  </div>
</template>
  
<script>
  
  export default {
    name: 'MapLocation',
    props: ['currentLocation'],
    data() {
      const { currentLocation, address, marker } = this || {};
      return {
        maploaded:false,
        searchText: '',
        thisMap: null, geocoder: null, thisloading: null,
        selectMarket: null, 
        latitude: null, longitude: null, address: '',
        mapHeight: 400,
      }
    },
    methods: {
      cancleClick(){
        this.$emit('cancle')
      },
      sendClick(){
        if(this.latitude && this.longitude){
          const location = { 
            latitude: this.latitude, 
            longitude: this.longitude, 
            address: this.address,
          };
          this.$emit('sendLocation', location)
        } else {
          this.$message({
            message: this.formatMessage({id:'5g.message.h5.address.select',defaultMessage:'请选择地址！'}),
            type: 'warning'
          })
        }
      },
    },

    mounted(){
      const _this = this;
      const mapCon = this.$refs.mapCon;
      this.mapHeight = mapCon.clientHeight;
      // _this.thisloading = _this.$loading({
      //   lock: true,
      //   text: '定位中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      const renderMap = () => {
        _this.thisMap = new BMap.Map('mapContainer');
        const map = _this.thisMap;
        map.centerAndZoom('北京市', 17); // 初始化地图,设置中心点坐标和地图级别
        map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
        _this.geocoder = new BMap.Geocoder();
        const addMarket = (lnglat, addressText) => {
          _this.latitude = lnglat.lat;
          _this.longitude = lnglat.lng;
          if(_this.selectMarket){
            _this.selectMarket.setPosition(new BMap.Point(lnglat.lng, lnglat.lat));
          } else {
            map.clearOverlays(); //清除地图上所有覆盖物
            _this.selectMarket = new BMap.Marker(lnglat);
            // 将创建的点标记添加到已有的地图实例：
            map.addOverlay(_this.selectMarket);
          }
          if(addressText){
            _this.address = addressText;
            _this.searchText = addressText;
          } else {
            _this.geocoder && _this.geocoder.getLocation(lnglat, function(result) {
              if (result.address) {
                // result为对应的地理位置详细信息
                let addressDetail= result.address;
                if (result.surroundingPois && result.surroundingPois.length > 0) {
                  addressDetail += result.surroundingPois[0].title;
                }
                _this.address = addressDetail;
                _this.searchText = addressDetail;
              } else {
                _this.address = '';
                _this.searchText = '';
              }
            })
          }
        }

        map.addEventListener('click', function (e) {
          console.log('map Click222', e);
          addMarket(e.point);
        });
        map.addEventListener('tilesloaded', function () {
          if (_this.maploaded) {
            return;
          }
          _this.maploaded = true;

          const geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              map.centerAndZoom(r.point, 17); // 初始化地图,设置中心点坐标和地图级别
            } else {
              function myFun(result) {
                 map.centerAndZoom(result.center, 17);
              }
              var myCity = new BMap.LocalCity();
              myCity.get(myFun);
            }
          });
          // 创建定位控件
          const locationControl = new BMap.GeolocationControl({
              // 控件的停靠位置（可选，默认左上角）
              anchor: BMAP_ANCHOR_TOP_RIGHT,
              // 控件基于停靠位置的偏移量（可选）
              offset: new BMap.Size(20, 20)
          });
           // 添加定位事件
          locationControl.addEventListener("locationSuccess", function(e){
              let address = '';
              address += e.addressComponent.province;
              address += e.addressComponent.city;
              address += e.addressComponent.district;
              address += e.addressComponent.street;
              address += e.addressComponent.streetNumber;
              map.centerAndZoom(e.point, 17); // 初始化地图,设置中心点坐标和地图级别
              addMarket(e.point,address);
          });

          // 将控件添加到地图上
          map.addControl(locationControl);

          let ac = new BMap.Autocomplete({ input: 'mapSearch', location: map }); //建立一个自动完成的对象
          let myValue;
          ac.addEventListener('onconfirm', function (e) {
            //鼠标点击下拉列表后的事件
            let _value = e.item.value;
            myValue =
              _value.province + _value.city + _value.district + _value.street + _value.business;
            setPlace();
          });

          function setPlace() {
            function myFun() {
              const pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
              map.centerAndZoom(pp, 18);
              addMarket(pp);
            }
            const local = new BMap.LocalSearch(map, {
              //智能搜索
              onSearchComplete: myFun,
            });
            local.search(myValue);
          }
          

        });
      }
      
      setTimeout(() => {
        renderMap();
      }, 500);
    }

  }
</script>

<style lang="less">
.tangram-suggestion-main{
  z-index: 9999;
}
  .page-con{
    max-width: 413px;
    height: 100%;
    border-right: 1px solid #dbdbdb;
  }
  .searchInput{
    width: calc(100% - 30px);
    max-width: 384px;
    height: 24px;
    line-height: 24px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    margin: 10px;
  }
  .locationText{
    line-height: 24px;
    background-color: #1890ff33;
    font-size: 12px;
    text-align: left;
    padding: 0 10px;
  }
  .map-con{
    height: calc( 100% - 100px );
    width: 100%;
    max-width: 414px;
  }
  .map{
    /* height: calc( 100% - 70px ); */
    /* height: 400px; */
    width: 100%;
    max-width: 414px;
  }
  .footer{
    text-align: right;
    position: absolute;
    bottom: 0;
    width: 100%;
    max-width: 414px;
  }
  .footer-btn{
    height: 28px;
    margin: 10px 0;
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/MapLocation.vue